var _style, _line, _line2, _line3, _line4, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermalActuatorByTempEffect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.1,
    y1: 8,
    x2: 6.1,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.2,
    y1: 8,
    x2: 9.2,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.5,
    y1: 8,
    x2: 12.6,
    y2: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.6,
    y1: 8,
    x2: 15.6,
    y2: 8
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "0.6,3.3 0.6,6.1 3.9,6.1 3.9,9.9 0.6,9.9 0.6,12.7 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermalActuatorByTempEffect);
export default __webpack_public_path__ + "static/media/ThermalActuatorByTempEffect.b84db1a99ed94a526f2979dd96954c4b.svg";
export { ForwardRef as ReactComponent };